import React from 'react'
import Header from '../Header/Header'
import Footer from '../Footer/Footer'
import useScrollToTop from '../../../hooks/useScrollToTop'
import './Layout.css'

const Layout = ({ children }) => {
  // Automatically scroll to top on route changes
  useScrollToTop()

  return (
    <div className="layout">
      <Header />
      <main className="main-content">
        {children}
      </main>
      <Footer />
    </div>
  )
}

export default Layout
